<div class="search" [ngClass]="{'confirm_address': (type === searchLocationTypeEnums.CONFIRM_ADDRESS)}">
  <img class="location_icon" src="assets/images/icons/location_icon_for_search.svg">
  <input type="text" [placeholder]="((citySearch? 'address.enter_delivery_city' : 'address.enter_delivery_address') | translate)"
         #searchInput
         [matAutocomplete]="yandexMapSelect"
         [value]="fullAddress || ''"
         (keyup)="searchAddressAndMakeLongLat(searchInput.value, (citySearch? 'city' : 'address'))"
  >
  <mat-autocomplete autoActiveFirstOption #yandexMapSelect="matAutocomplete" class="panel_class_for_address_search">
    @if (!citySearch) {
      <mat-option class="searched_values"  *ngFor="let option of locations"
                  [value]="option.properties.get('name')"
                  (onSelectionChange)="addressOrCitySelection(option,'address')">
        <div class="flex_align_center address">
          <img src="assets/images/icons/location_Icon_for_mat_options.svg">
          <div class="ml_12 flex_column values_text">
            <div class="address_name" [innerHTML]="searchInput.value | searchInString : option.streetAndHouse">
            </div>
            <div class="city_name">
              {{option.cityAndRegion}}
            </div>
          </div>
          <img src="assets/images/icons/navbar/arrow_left_icon.svg" class="arrow_right">
        </div>
      </mat-option>
    } @else {
      <mat-option *ngFor="let city of arrayOfSearchedCity" [value]="city.name"
                  (onSelectionChange)="addressOrCitySelection(city,'city')">
        <div class="flex_align_center">
          <img src="assets/images/icons/location_Icon_for_mat_options.svg">
          <div class="address_name ml_12" [innerHTML]="searchInput.value | searchInString : city.name">
          </div>
        </div>
      </mat-option>
    }
  </mat-autocomplete>
</div>
